import { createSlice } from '@reduxjs/toolkit';
import { UserNotification } from '@core/modeles/Notifimodels.ts';
import {
  fetchNotifications,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  markNotificationAsUnread, 
} from '@core/actions/NotificationActions.ts';

interface NotificationState {
  list: UserNotification[];
  loading: boolean;
}

const initialState: NotificationState = {
  list: [],
  loading: false,
};

const notificationSlice = createSlice({
  name: 'notification_admin',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state) => {
        state.loading = false;
      })

      .addCase(markNotificationAsRead.fulfilled, (state, action) => {
        const notification = state.list.find((n) => n.id === action.payload);
        if (notification) {
          notification.read = true;
        }
      })
      .addCase(markNotificationAsUnread.fulfilled, (state, action) => {
        const notification = state.list.find((n) => n.id === action.payload);
        if (notification) {
          notification.read = false;
        }
      })

      .addCase(markAllNotificationsAsRead.fulfilled, (state) => {
        state.list = state.list.map((n) => ({ ...n, read: true }));
      });
  },
});

export default notificationSlice.reducer;
